import React from 'react'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {
  DEFAULT_PROVIDER_CODE,
  DEFAULT_PROVIDER_NAME,
  getProviderName
} from '@vio/core/src/offer/business/provider'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

const StyledText = styled(Text)`
  color: ${cssTheme.colors.content.neutral.primary};
`

interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** Provider code **/
  providerCode: string
  /** The size of the text */
  size?: 'sm' | 'md'
  /** The brand info to display*/
  brandInfo?: SearchOffer['metadata']['brandInfo'] | null
}

export const ProviderName: React.FC<Props> = ({
  providerCode,
  size = 'md',
  className,
  brandInfo = null
}) => {
  if (brandInfo?.brandName) {
    return (
      <StyledText
        tag="span"
        variant={size === 'sm' ? 'bodyXS' : 'labelS'}
        className={className}
      >
        {brandInfo.brandName}
      </StyledText>
    )
  }

  let providerName = getProviderName(providerCode)

  if (!providerName) {
    providerCode = DEFAULT_PROVIDER_CODE
    providerName = DEFAULT_PROVIDER_NAME
  }

  return (
    <StyledText
      tag="span"
      variant={size === 'sm' ? 'bodyXS' : 'titleS'}
      className={className}
    >
      {providerName}
    </StyledText>
  )
}
